var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard_warp"},[_c('img',{staticStyle:{"width":"calc(100% - 0px)","height":"calc(100vh - 88px)"},attrs:{"src":_vm.dashboardBg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }